import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "flex justify-between items-center font-medium text-sm p-6" }
const _hoisted_3 = { class: "flex gap-5" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "min-w-full bg-white border-none text-left" }
const _hoisted_7 = { class: "bg-gray-50 font-semibold text-xs text-gray-700" }
const _hoisted_8 = { class: "border-b border-gray-200" }
const _hoisted_9 = { class: "border-y border-y-gray-200 pl-6" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "flex gap-1 hover:cursor-pointer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex gap-1 hover:cursor-pointer" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex gap-1 hover:cursor-pointer" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "flex gap-1 hover:cursor-pointer" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { class: "border-y border-y-gray-200 py-3 pr-6 text-gray-600 font-medium text-xs" }, null, -1)
const _hoisted_29 = { class: "font-medium text-sm text-gray-400" }
const _hoisted_30 = { class: "text-start pl-6 border-b border-b-gray-200" }
const _hoisted_31 = ["value"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex items-center gap-[6px] justify-end pr-6 py-6 border-b border-b-gray-200" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "w-5 h-5"
}
const _hoisted_39 = { class: "pagination w-full flex justify-center items-center gap-2 py-6" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "p-6 text-center" }
const _hoisted_42 = { class: "text-xl font-semibold text-gray-900 mb-8" }
const _hoisted_43 = { class: "text-gray-600 mb-8" }
const _hoisted_44 = { class: "p-6 text-center" }
const _hoisted_45 = { class: "text-xl font-semibold text-gray-900 mb-6" }
const _hoisted_46 = { class: "text-gray-600 mb-8" }
const _hoisted_47 = { class: "flex items-center justify-center w-full gap-x-6" }

import { onMounted, computed, ref, watch, inject } from "vue";
import bulkEditLearners from "../components/BulkEditLearnersComponent.vue";
import bulkUploadLearners from "../components/BulkLearnersUploadComponent.vue";
import UpdateLearnerComponent from "./UpdateLearnerComponent.vue";
import AddLearnerModalComponent from "./AddLearnerModalComponent.vue";
import TutorialModalComponent from "../components/TutorialModalComponent.vue";
import { useUserStore } from "@/stores/userStore";
import { useLicenseStore } from "@/stores/licenseStore";
import { useFilterStore } from "@/stores/filterStore";
import PreviewBulkUploadComponent from "./PreviewBulkUploadComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentTable',
  props: {
  students: {
    type: Object,
    required: true,
  },
  classId: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    required: true,
  },
  gradeLevel: {
    type: Number,
    required: true,
  },
  preferredLanguage: {
    type: String,
    required: true,
  },
  subject: {
    type: String,
    required: true,
  },
  search: {
    type: String,
    required: false,
  },
  allowedClassGroupIds: {
    type: Array as () => string[],
    required: false,
    default: () => [],
  },
  hidePrimaryNav: {
    type: Boolean,
    required: false,
  },
},
  emits: ["classGroupId", "transmitFinalLearners"],
  setup(__props, { emit }) {

const props = __props;

const userStore = useUserStore();
const licenseStore = useLicenseStore();
const filterStore = useFilterStore();

const bus = inject("bus") as any;

// Define props that the component accepts


// Reactive variables to manage component state
const showAddView = ref(false);
const showGenerateEmails = ref(false);
const showLearnersUploadPreview = ref(false);
const learnersToUpload = ref<any>([]);
const itemsPerPage = ref(16);
const currentPage = ref(1);
const selectedStudents = ref<string[]>([]);
const filteredStudents = ref(props.students);
const bulkEdit = ref(false);
const updateLearner = ref(false);
const showModal = ref(false);
const hidePrimaryNav = ref(props.hidePrimaryNav);
const showPermissionDeniedModal = ref(false);
const showLearnersUploadPromptModal = ref(false);
const sortKey = ref('');
const sortOrder = ref('asc');

onMounted(() => {
  if (props.allowedClassGroupIds.includes(props.classId)) {
    if (paginatedStudents.value.length <= 0) {
      showLearnersUploadPromptModal.value = true;
    }
  }
});

const sortTable = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }

  filteredStudents.value.sort((a: any, b: any) => {
    let result = 0;
    if (a[key] < b[key]) {
      result = -1;
    } else if (a[key] > b[key]) {
      result = 1;
    }
    return sortOrder.value === 'asc' ? result : -result;
  });
};

// Methods to handle actions with permission checks
const handleCreateStudent = () => {
  if (canPerformGeneralAction.value) {
    showAddView.value = true;
  } else {
    showPermissionDeniedModal.value = true;
  }
};

const resetEditModal = () => {
  updateLearner.value = false;
  selectedStudents.value = [];
};

const handleBulkUpload = () => {
  if (canPerformGeneralAction.value) {
    showGenerateEmails.value = true;
  } else {
    showPermissionDeniedModal.value = true;
  }
};

const handleBulkEdit = () => {
  if (canPerformGeneralAction.value) {
    if (selectedStudents.value.length >= 2) {
      bulkEdit.value = true;
    }
  } else {
    showPermissionDeniedModal.value = true;
  }
};

const handleEditSingleLearner = (student: any) => {
  if (canPerformGeneralAction.value) {
    editSingleLearner(student.id);
  } else {
    showPermissionDeniedModal.value = true;
  }
};

const isSchoolAdmin = computed(() => userStore.isSchoolAdmin);
const isInternalAdmin = computed(() => userStore.isInternalAdmin);
const isSchoolGroupAdmin = computed(() => userStore.isSchoolGroupAdmin);
const isClassGroupAdmin = computed(() => userStore.isClassGroupAdmin);

// Computed property to check if general actions are permitted
const canPerformGeneralAction = computed(() => {
  return (
    isSchoolAdmin.value ||
    isInternalAdmin.value ||
    isSchoolGroupAdmin.value ||
    isClassGroupAdmin.value ||
    props.allowedClassGroupIds.includes(props.classId)
  );
});

const showStudentSummary = (student: any) => {
  bus.emit("show-student-modal", { userId: student.id });
};

// Computed property to check if all students in the current page are selected
const areAllSelected = computed(() => {
  return (
    paginatedStudents.value.length > 0 &&
    paginatedStudents.value.every((student: any) =>
      selectedStudents.value.includes(student.id)
    )
  );
});

/**
 * Show the table nav buttons if the hidePrimaryNav prop is NOT set
 */
const showPrimaryNav = computed(() => {
  return hidePrimaryNav.value ? false : true;
});

// Method to toggle select all learners on the current page
const toggleSelectAll = () => {
  if (areAllSelected.value) {
    // Deselect all students
    selectedStudents.value = selectedStudents.value.filter(
      (id) => !paginatedStudents.value.some((student: any) => student.id === id)
    );
  } else {
    // Select all students on the current page
    const studentIds = paginatedStudents.value.map(
      (student: any) => student.id
    );
    selectedStudents.value = [
      ...new Set([...selectedStudents.value, ...studentIds]),
    ]; // Add new ones to avoid duplicates
  }
};

//Hide add a learner modal
const closeAddLearnerModal = () => {
  showAddView.value = false;
};

// Emit events to parent components


//Watcher for the search prop to filter students based on search input
watch(
  () => props.search,
  (newSearch: any) => {
    filteredStudents.value = props.students.filter(
      (student: any) =>
        student.firstName.toLowerCase().includes(newSearch.toLowerCase()) ||
        student.lastName.toLowerCase().includes(newSearch.toLowerCase()) ||
        student.email.toLowerCase().includes(newSearch.toLowerCase())
    );
  },
  { immediate: true }
);

// Watcher for the students prop to update the filtered students list when students data changes
watch(
  () => props.students,
  (newUpdate: any) => {
    filteredStudents.value = newUpdate;
  },
  { immediate: true }
);

// Computed property to calculate the total number of pages based on students list and items per page
const totalPages = computed(() => {
  return Math.ceil(props.students.length / itemsPerPage.value);
});

// Computed property to get the paginated list of students based on current page and items per page
const paginatedStudents = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return filteredStudents.value.slice(start, end);
});

// Function to clear the selected learners and reset bulk edit mode
const clearnLearners = () => {
  selectedStudents.value = [];
  bulkEdit.value = false;
  updateLearner.value = false;
};

// Function to enable edit mode for a single learner by selecting their ID
const editSingleLearner = (studentId: string) => {
  selectedStudents.value = [];
  selectedStudents.value.push(studentId);
  updateLearner.value = true;
};

// Function to check if a learner is selected
const isLearnerSelected = (studentId: string) => {
  return selectedStudents.value.includes(studentId);
};

// Function to change the current page in the pagination
const goToPage = (page: number) => {
  currentPage.value = page;
};

// Function to handle the reception of uploaded learners
const receiveLearnersToUpload = (learners: any) => {
  learnersToUpload.value = JSON.parse(JSON.stringify(learners));
  showLearnersUploadPreview.value = true;
};

const handleFinalUpload = (learners: any) => {
  console.log(learners, "Final learners to upload");
  showLearnersUploadPreview.value = false;
  emit("transmitFinalLearners", learners);
};

const isSubjectLicenseSeatsExceeded = computed(() => {
  return licenseStore.isSubjectLicenseSeatsExceeded(
    filterStore.selectedFilters.subject
  );
});

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (showPrimaryNav.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass('text-[#344054] text-semibold py-2.5 px-4 rounded-lg flex gap-1 border border-[#D0D5DD] ' + (_unref(licenseStore).license==null || _unref(licenseStore).loader.fetchingLicenses ? 'cursor-not-allowed' : 'cursor-pointer')),
                onClick: handleCreateStudent,
                disabled: isSubjectLicenseSeatsExceeded.value || _unref(licenseStore).license==null || _unref(licenseStore).loader.fetchingLicenses
              }, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-plus',
                  title: 'rl plus',
                  "aria-hidden": "true"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("student_table_view.new_student")), 1)
              ], 10, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(
          'text-gray-700 text-semibold py-2.5 px-4 rounded-lg flex gap-1 border border-gray-300 ' +
          (selectedStudents.value.length >= 2
            ? 'cursor-pointer'
            : 'cursor-not-allowed')
        ),
          onClick: handleBulkEdit,
          disabled: selectedStudents.value.length < 2
        }, [
          _createVNode(_component_rl_icon, {
            icon: 'rl-bulk-edit',
            title: 'rl bulk-edit',
            "aria-hidden": "true"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("student_table_view.bulk_edit")), 1)
        ], 10, _hoisted_5)
      ]),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", _hoisted_7, [
          _createElementVNode("tr", _hoisted_8, [
            _createElementVNode("th", _hoisted_9, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: areAllSelected.value,
                onChange: toggleSelectAll,
                class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600"
              }, null, 40, _hoisted_10)
            ]),
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sortTable('firstName')))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.$t("student_table_view.table.first_name")), 1),
                _hoisted_12,
                (sortKey.value === 'firstName'|| sortKey.value === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      (sortOrder.value === 'asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " ▲ "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, " ▼ "))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('lastName')))
            }, [
              _createElementVNode("span", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.$t("student_table_view.table.last_name")) + " ", 1),
                (sortKey.value === 'lastName' || sortKey.value === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      (sortOrder.value === 'asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, " ▲ "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, " ▼ "))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs cursor-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('email')))
            }, [
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t("student_table_view.table.email")) + " ", 1),
                (sortKey.value === 'email'|| sortKey.value === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      (sortOrder.value === 'asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, " ▲ "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_23, " ▼ "))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("th", {
              class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs cursor-pointer",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable('status')))
            }, [
              _createElementVNode("span", _hoisted_24, [
                _createTextVNode(_toDisplayString(_ctx.$t("student_table_view.table.status")) + " ", 1),
                (sortKey.value === 'status'|| sortKey.value === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                      (sortOrder.value === 'asc')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, " ▲ "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_27, " ▼ "))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_28
          ])
        ]),
        _createElementVNode("tbody", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedStudents.value, (student) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: student.id,
              class: "cursor-pointer"
            }, [
              _createElementVNode("td", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedStudents).value = $event)),
                  value: student.id,
                  class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600"
                }, null, 8, _hoisted_31), [
                  [_vModelCheckbox, selectedStudents.value]
                ])
              ]),
              _createElementVNode("td", {
                onClick: ($event: any) => (showStudentSummary(student)),
                class: "text-gray-900 text-sm py-6 font-medium border-b border-b-gray-200"
              }, _toDisplayString(student.firstName), 9, _hoisted_32),
              _createElementVNode("td", {
                onClick: ($event: any) => (showStudentSummary(student)),
                class: "text-gray-600 text-sm py-6 border-b border-b-gray-200"
              }, _toDisplayString(student.lastName), 9, _hoisted_33),
              _createElementVNode("td", {
                onClick: ($event: any) => (showStudentSummary(student)),
                class: "text-gray-600 text-sm py-6 border-b border-b-gray-200"
              }, _toDisplayString(student.email), 9, _hoisted_34),
              _createElementVNode("td", {
                onClick: ($event: any) => (showStudentSummary(student)),
                class: "text-gray-600 text-sm py-6 border-b border-b-gray-200"
              }, _toDisplayString(student.status), 9, _hoisted_35),
              _createElementVNode("td", _hoisted_36, [
                (!isLearnerSelected(student.id))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "",
                      onClick: ($event: any) => (handleEditSingleLearner(student))
                    }, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-bulk-edit',
                        title: 'rl bulk-edit',
                        "aria-hidden": "true"
                      })
                    ], 8, _hoisted_37))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
          return (_openBlock(), _createElementBlock("button", {
            key: page,
            class: _normalizeClass(["text-gray-600 rounded-sm p-2 text-xs font-medium w-6 h-6 leading-none flex justify-center items-center", { '!text-gray-900': currentPage.value === page }]),
            onClick: ($event: any) => (goToPage(page))
          }, _toDisplayString(page), 11, _hoisted_40))
        }), 128))
      ])
    ]),
    (showGenerateEmails.value)
      ? (_openBlock(), _createBlock(bulkUploadLearners, {
          key: 0,
          uploadType: 'class',
          classId: __props.classId,
          className: __props.className,
          onTransmitLearnersToUpload: receiveLearnersToUpload,
          onResetModalState: _cache[5] || (_cache[5] = ($event: any) => (showGenerateEmails.value = false))
        }, null, 8, ["classId", "className"]))
      : _createCommentVNode("", true),
    (bulkEdit.value)
      ? (_openBlock(), _createBlock(bulkEditLearners, {
          key: 1,
          gradeLevel: __props.gradeLevel,
          subject: __props.subject,
          classId: __props.classId,
          preferredLanguage: __props.preferredLanguage,
          selectedStudents: selectedStudents.value,
          onHideModel: clearnLearners,
          onResetEditModel: clearnLearners
        }, null, 8, ["gradeLevel", "subject", "classId", "preferredLanguage", "selectedStudents"]))
      : _createCommentVNode("", true),
    (updateLearner.value)
      ? (_openBlock(), _createBlock(UpdateLearnerComponent, {
          key: 2,
          preferredLanguage: __props.preferredLanguage,
          gradeLevel: __props.gradeLevel,
          subject: __props.subject,
          classId: __props.classId,
          selectedStudents: selectedStudents.value,
          onCloseUpdate: clearnLearners,
          onResetEditModel: clearnLearners
        }, null, 8, ["preferredLanguage", "gradeLevel", "subject", "classId", "selectedStudents"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-5xl',
      open: showLearnersUploadPreview.value,
      onLocalModalOpen: _cache[7] || (_cache[7] = ($event: any) => (showLearnersUploadPreview.value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(PreviewBulkUploadComponent, {
          uploadType: 'class',
          className: props.className,
          classId: props.classId,
          learnersToUpload: learnersToUpload.value,
          onTransmitFinalLearners: handleFinalUpload,
          onCancelPreview: _cache[6] || (_cache[6] = ($event: any) => (showLearnersUploadPreview.value = false))
        }, null, 8, ["className", "classId", "learnersToUpload"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-sm',
      open: showPermissionDeniedModal.value,
      onLocalModalOpen: _cache[9] || (_cache[9] = ($event: any) => (showPermissionDeniedModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("h2", _hoisted_42, _toDisplayString(_ctx.$t("modals.teacher_class_permission.title")), 1),
          _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("modals.teacher_class_permission.description")), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (showPermissionDeniedModal.value = false)),
            class: "w-full rounded-md bg-white px-2.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          }, _toDisplayString(_ctx.$t("modals.teacher_class_permission.btns.ok")), 1)
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-sm',
      open: showLearnersUploadPromptModal.value,
      onLocalModalOpen: _cache[12] || (_cache[12] = ($event: any) => (showLearnersUploadPromptModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("h2", _hoisted_45, _toDisplayString(_ctx.$t("modals.teacher_add_learners_prompt.title")), 1),
          _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("modals.teacher_add_learners_prompt.description")), 1),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (showLearnersUploadPromptModal.value = false)),
              class: "flex-1 rounded-md bg-white px-2.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
            }, _toDisplayString(_ctx.$t("modals.teacher_add_learners_prompt.btns.cancel")), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[11] || (_cache[11] = ($event: any) => {
            showGenerateEmails.value = true;
            showLearnersUploadPromptModal.value = false;
          }),
              class: "flex-1 rounded-md bg-blue-600 px-2.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            }, _toDisplayString(_ctx.$t("modals.teacher_add_learners_prompt.btns.ok")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    (showAddView.value)
      ? (_openBlock(), _createBlock(AddLearnerModalComponent, {
          key: 3,
          className: __props.className,
          classId: __props.classId,
          onHideModel: closeAddLearnerModal
        }, null, 8, ["className", "classId"]))
      : _createCommentVNode("", true),
    _createVNode(TutorialModalComponent, {
      show: showModal.value,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((showModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})